import { SanityCategoryTableBlock } from '../../types/generated/graphql-types'
import { CategoryTableProps } from '../components/blocks/CategoryTable'
import { TextWithTableProps } from '../components/blocks/TextWithTable'
import { Breakpoints } from '../utilities/breakpoints'
import { notEmpty } from '../utilities/filters'
import { validImage } from '../utilities/imageFilters'
import { Presets } from '../utilities/imagePreset'
import { getImagePropsWithSources } from '../utilities/imagePropUtils'
import { mapSanityLinkToInternalExternalLink } from './LinkMapper'

export const sanityCategoryTableBlockToTextWithTableProps = ({
  boxText,
  button,
  heading,
  links,
  preamble,
  subheading,
}: SanityCategoryTableBlock): TextWithTableProps => ({
  button: button ? mapSanityLinkToInternalExternalLink(button) : undefined,
  heading: heading ?? undefined,
  links:
    links?.filter(notEmpty).map(link => mapSanityLinkToInternalExternalLink(link)) ??
    undefined,
  linksText: boxText ?? undefined,
  preamble: preamble ?? undefined,
  subtitle: subheading ?? undefined,
})

export const sanityCategoryTableBlockToCategoryTableProps = ({
  button,
  heading,
  image,
  links,
  preamble,
  subheading,
}: SanityCategoryTableBlock): CategoryTableProps => ({
  button: button ? mapSanityLinkToInternalExternalLink(button) : undefined,
  heading: heading ?? '',
  imageProps: validImage(image)
    ? getImagePropsWithSources(
        image,
        {
          small: Presets.categoryTableBlock.portrait.small,
          medium: Presets.categoryTableBlock.landscape.medium,
          large: Presets.categoryTableBlock.landscape.large,
          extraLarge: Presets.categoryTableBlock.landscape.extraLarge,
        },
        Breakpoints.tb,
        Breakpoints.lg,
        Breakpoints.xl
      )
    : undefined,
  links:
    links?.filter(notEmpty).map(link => mapSanityLinkToInternalExternalLink(link)) ??
    undefined,
  preamble: preamble ?? '',
  subheading: subheading ?? '',
})
